import EventBus from "@plugins/common/service/eventbus";

const html5InteractiveEventBus = new EventBus();
export default html5InteractiveEventBus;
